export default function Home() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-lg text-center">
        <h1 className="text-4xl font-bold mb-4">VideoLink</h1>
        <p className="text-concrete">
          Use a personal invite link to record your video message.
        </p>
      </div>
    </div>
  );
}
